import getStore from '../store/store';
import * as trace from 'owa-trace';
import {
    ApplicationSettingGroup,
    ApplicationSettingKey,
    ApplicationSettings,
} from '../store/schema/ApplicationSettings';

export default function getApplicationSetting<
    TGroup extends ApplicationSettingGroup,
    TKey extends ApplicationSettingKey<TGroup>
>(group: TGroup, setting: TKey): ApplicationSettings[TGroup][TKey] {
    const store = getStore();
    if (!store.initialized && !process.env.JEST_WORKER_ID) {
        trace.errorThatWillCauseAlert(
            `Attempted to read ${group}.${setting} before application settings were initialized.`
        );
    }

    return store.settings[group][setting];
}
